export const setUpPageHeader = function() {
	document.addEventListener("click", function(event) {
		// クリックされた要素が指定されたセレクターに一致するか確認
		const searchBox = document.querySelector(".wp-block-new-standard-page-header__search");

		if ( searchBox ) {
			const buttonEl = event.target.closest(".wp-block-new-standard-page-header-navigations__icon-buttons__button.--search");

			if ( buttonEl ) {
				searchBox.classList.toggle("--show")
			} else {
				if ( searchBox.classList.contains( "--show" ) ) {
					const clickedCloseButton = event.target.closest(".wp-block-new-standard-page-header__search__button-close");
					const clickedSearchBox = event.target.closest(".wp-block-new-standard-page-header__search");

					if ( clickedCloseButton || ! clickedSearchBox ) {
						searchBox.classList.remove("--show");
					}
				}
			}
		}
	});
};
